import React, { useState } from "react";
import Header from "../../CommonComponents/header";
import { Footer } from "../../CommonComponents/footer";
import { Heading } from "../../subComponents/Heading";
import { Text } from "../../subComponents/text";
import { MobileHeader } from "../../CommonComponents/mobileHeader";
import { baseurl } from "../../CommonComponents/baseurl";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export const BecomeAdealerPage = () => {
  const [customer_name, setCustomerName] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [comment, setComment] = useState("");
  const [type, setType] = useState("dealership_request");
  const [phone_number, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [required_service, setRequiredService] = useState("uPVC");
  const [otherdescription, setOtherDescription] = useState("");

  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [open, setOpen] = React.useState(false);

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    // Allow only numeric values
    if (/^\d*$/.test(value)) {
      if (value.length <= 15) {
        setPhoneNumber(value);
        setPhoneNumberError("");
      } else {
        setPhoneNumberError("Cannot enter more than 15 characters");
        handleClick();
      }
    } else {
      setPhoneNumberError("Only numeric values are allowed");
      handleClick();
    }
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const validateForm = () => {
    if (!customer_name) {
      setError("Name is required");
      handleClick();
      return false;
    }
    if (!phone_number) {
      setError("Phone number is required");
      handleClick();
      return false;
    }
    if (!state) {
      setError("State is required");
      handleClick();
      return false;
    }
    if (!state) {
      setError("State is required");
      handleClick();
      return false;
    }

    if (!city) {
      setError("City is required");
      handleClick();
      return false;
    }
    // if (!email) {
    //   setError("Email is required");
    //   handleClick();
    //   return false;
    // }
    if (required_service === "other" && !otherdescription) {
      setError("Please specify the service");
      handleClick();
      return false;
    }
    setError(""); // Clear any previous error
    return true;
  };

  const formSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      const response = await fetch(`${baseurl}/api/contact-us`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_name,
          phone_number,
          email,
          required_service,
          otherdescription,
          state,
          comment,
          type,
          city,
        }),
      });

      const data = await response.json();
      if (data.success === "1") {
        setSuccessMessage(data.message);
        clearForm();
        handleClick();
        // handleOpen2();
      } else {
        console.error("Failed to submit data:", data.message);
        setError(data.message);
        console.log(data.message);
        handleClick();
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      setError("An error occurred. Please try again.");
      handleClick();
    }
  };

  const clearForm = () => {
    setCustomerName("");
    setState("");
    setComment("");
    setPhoneNumber("");
    setEmail("");
    setRequiredService("uPVC");
    setOtherDescription("");
    setCity("");
  };

  return (
    <>
      <Header />
      <MobileHeader />
      <div className="desktop_header_spacer"></div>

      <section className="blog_hero_section becaom_dealer_hero_section">
        <div className="blog_hero_banner">
          <img
            src={"/assets/images/become_our_Dealer1.jpg"}
            alt={"blog.png"}
            width={"100%"}
          />
        </div>
        <div className="blog_hero_banner_overlay">
          <div className="innerblog_hero_content">
            <Heading title={"Become a Dealer"} />
            {/* <Text
              text={
                "Become an Tube Flex India dealer, offer premium products, and grow!"
              }
            /> */}
          </div>
        </div>
      </section>
      <br />
      <br />

      <div className="become_Dealer_container">
        <Heading
          title={"Partner with Tube Flex India and Expand Your Business Today!"}
        />
        <br />
        <Text
          text={`Become an Tube Flex India Dealer: Partner with the Best in Aluminum Solutions
Are you looking to expand your business and offer high-quality aluminum products to your customers? Partner with Tube Flex India and become an authorized dealer! We offer a comprehensive range of aluminum solutions, renowned for their durability, versatility, and aesthetic appeal. Joining our dealer network gives you access to premium products, competitive pricing, and dedicated support to help you succeed.
Why Choose Tube Flex India?`}
        />

        <div className="inner_become_Dealer_container">
          <div className="left_inner_become_Dealer_container">
            <Text
              text={`	•	Premium Quality Products: We pride ourselves on delivering top-tier aluminum products, manufactured to the highest industry standards. Our range includes [mention specific product categories, e.g., aluminum extrusions, sheets, profiles, composite panels, etc.], catering to diverse applications in construction, architecture, and manufacturing.`}
            />
            <Text
              text={`•	Competitive Pricing: Benefit from attractive pricing structures that maximize your profit margins. We offer competitive rates and volume discounts to help you stay ahead in the market.`}
            />
            <Text
              text={`•	Comprehensive Product Range: Offer your customers a diverse selection of aluminum solutions, all under one roof. This eliminates the need for them to source products from multiple suppliers, making your business a one-stop shop for all their aluminum needs.`}
            />
            <Text
              text={`	•	Marketing Support: We provide our dealers with marketing materials and resources to help them promote our products effectively. This includes [mention specific marketing support, e.g., brochures, product catalogs, digital marketing assets, co-branded materials, etc.].`}
            />
            <Text
              text={`	•	Technical Support: Our team of experts is available to provide technical assistance and guidance on our products. We offer training programs and ongoing support to ensure you have the knowledge and expertise to serve your customers effectively.`}
            />
            <Text
              text={`•	Established Brand Reputation: Tube Flex India is a trusted name in the aluminum industry, known for its quality and reliability. Partnering with us allows you to leverage our established brand reputation and build trust with your customers.`}
            />
            <Text
              text={`	•	Growth Opportunities: We are committed to the success of our dealers and offer ongoing support and opportunities for growth. As our network expands, you'll benefit from increased brand visibility and business opportunities.`}
            />
          </div>

          <div className="right_inner_become_Dealer_container">
            <div className="innergetin_touch_right_container shadow">
              <Text
                style={{ color: "#fff", fontSize: "1.3rem" }}
                text={"Tell us about your project"}
              />
              <div className="form_input_feild_container">
                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0", color: "#fff" }}>Name</p>
                  </div>
                  <div className="input_feild">
                    <input
                      className="contact_form_input_feild"
                      type="text"
                      placeholder="Enter your name"
                      maxLength={35}
                      value={customer_name}
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0", color: "#fff" }}>
                      Phone Number
                    </p>
                  </div>
                  <div className="input_feild">
                    <input
                      className="contact_form_input_feild"
                      type="text"
                      placeholder="Enter your phone number"
                      maxLength={13}
                      value={phone_number}
                      onChange={handlePhoneNumberChange}
                    />
                  </div>
                </div>

                {required_service === "other" ? (
                  <div className="pricing_container">
                    <div className="input_feild_title">
                      <p style={{ marginBottom: "0", color: "#fff" }}></p>
                    </div>
                    <div className="input_feild">
                      <input
                        className="contact_form_input_feild"
                        type="text"
                        placeholder="Please specify"
                        maxLength={50}
                        value={otherdescription}
                        onChange={(e) => setOtherDescription(e.target.value)}
                      />
                    </div>
                  </div>
                ) : null}

                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0", color: "#fff" }}>Email ID</p>
                  </div>
                  <div className="input_feild">
                    <input
                      type="email"
                      className="contact_form_input_feild"
                      placeholder="Enter your email"
                      maxLength={70}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0", color: "#fff" }}>State</p>
                  </div>
                  <div className="input_feild">
                    <input
                      className="contact_form_input_feild"
                      type="text"
                      placeholder="Enter your State"
                      maxLength={15}
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                    />
                  </div>
                </div>

                <div className="pricing_container">
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0", color: "#fff" }}>City</p>
                  </div>
                  <div className="input_feild">
                    <input
                      className="contact_form_input_feild"
                      type="text"
                      placeholder="Enter your City"
                      maxLength={15}
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className="pricing_container"
                  style={{ alignItems: "start" }}
                >
                  <div className="input_feild_title">
                    <p style={{ marginBottom: "0", color: "#fff" }}>Comment</p>
                  </div>
                  <div className="input_feild">
                    <textarea
                      className="contact_form_input_feild"
                      type="text"
                      rows="3"
                      placeholder="Enter your Comment"
                      maxLength={35}
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    />
                  </div>
                </div>

                <button className="form_btn" onClick={formSubmit}>
                  Submit
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 15 15"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      d="m13.5 7.5l-4-4m4 4l-4 4m4-4H1"
                    />
                  </svg>
                </button>

                <Snackbar
                  open={open}
                  autoHideDuration={3000}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <Alert
                    onClose={handleClose}
                    severity={error ? "error" : "success"}
                  >
                    {error || successMessage || phoneNumberError}
                  </Alert>
                </Snackbar>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner_become_Dealer_container2">
        <Heading
          title={`Who We Are Looking For:
We are seeking motivated and enthusiastic individuals or businesses with:`}
        />
        <Text
          text={`	•	A strong understanding of the construction or related industries (preferred).`}
        />
        <Text text={`	•	Excellent customer service skills.`} />
        <Text
          text={`	•	A commitment to providing high-quality products and services.`}
        />
        <Text text={`	•	A desire to grow and succeed.`} />
      </div>
      <br />
      <br />
      {/* footer start from here */}
      <Footer />
      {/* footer close from here */}
    </>
  );
};
